@let enrichedMenuData = (enrichedMenuData$ | async) ?? [];
@if (enrichedMenuData.length > 0) {
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Navigate">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">

        @for (menuItem of enrichedMenuData; track menuItem.key) {
            <button mat-menu-item [routerLink]="menuItem.route" [class.selected]="menuItem.selected">
                @if(menuItem.icon != null) {
                    <mat-icon>{{ menuItem.icon }}</mat-icon>
                }
                <span>{{ menuItem.key | translate}}</span>
            </button>
        }
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Log Out</span>
        </button>
    </mat-menu>
} @else {
    <button mat-button aria-label="Navigate"(click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Log Out</span>
    </button>
}
